export const BaseApi = process.env.REACT_APP_BASE_API;
export const BaseUrl = process.env.REACT_APP_BASE_URL;
export const fileUrl = process.env.REACT_APP_FILE_URL;
export const PublicFileUrl = process.env.REACT_APP_PUBLIC_FILE_URL;
